import {Grid} from "../Grid";
import {BACKGROUND_COLOUR, BORDERS, PAD_EXTRA_LARGE_NUMBER} from "../../providers/designSystem";
import {TextField} from "@mui/material";
import {PrimaryButton} from "../Buttons";
import {Flexbox} from "../Flexbox";
import {SelectedColourSwatch} from "../ColourSwatch/SelectedColourSwatch";
import React from "react";
import {DNDSortableContext} from "../DNDComponents/DNDSortableContext";
import {SortableItem} from "../DNDComponents/SortableItem";


const SelectedColours = ({
                             colours,
                             setColours,
                             selectedColours,
                             setSelectedColours
                         }) => {
    return (
        <Flexbox
            gap={16}
            padding={16}
            border={BORDERS.grey}
            height="40vh"
            overflowY="scroll"
            backgroundColour="#f9f9fb"
        >
            <DNDSortableContext items={selectedColours} setItems={setSelectedColours}>
                {selectedColours?.map((colour) => {
                    return (
                        <SortableItem key={colour.id} id={colour.id}>
                            <SelectedColourSwatch
                                data-testid={`selected-colour-swatch-${colour.id}`}
                                id={colour.id}
                                currentColour={colour}
                                colours={colours}
                                setColours={setColours}
                                selectedColours={selectedColours}
                                setSelectedColours={setSelectedColours}
                            />
                        </SortableItem>
                    );
                })}
            </DNDSortableContext>
        </Flexbox>
    );
};
export const ColourPaletteValues = ({
                                        colours,
                                        setColours,
                                        selectedColours,
                                        setSelectedColours,
                                        name,
                                        setName,
                                        buttonText,
                                        submitColourPalette,
                                    }) => {
    return (
        <Grid
            numberOfColumns={1}
            backgroundColour={BACKGROUND_COLOUR}
            borderRadius={12}
            gap={12}
            height="65vh"
            paddingX={PAD_EXTRA_LARGE_NUMBER}
            paddingY={PAD_EXTRA_LARGE_NUMBER}
        >
            <TextField
                label={'Name'}
                defaultValue={name}
                onChange={e => setName(e.target.value)}
                size="small"
            />

            <SelectedColours
                colours={colours}
                setColours={setColours}
                selectedColours={selectedColours}
                setSelectedColours={setSelectedColours}
            />
            <PrimaryButton onClick={() => submitColourPalette(name, selectedColours)}>{buttonText}</PrimaryButton>
        </Grid>
    );
};
